<div
  class="bg-white rounded-lg p-10 min-w-sm lg:w-[506px] max-w-[506px] w-full">
  <h2 class="text-lg font-medium sm:text-xl md:text-2xl text-center mb-5">
    Create a New Account
  </h2>

  <form
    appRegisterSubmit
    [appDynamicPhoneValidation]="dynamicPhoneValidationConfig"
    autocomplete="off"
    [formGroup]="registerForm"
    class="flex flex-col gap-4">
    <p class="text-sm italic neutral-900 font-bold">
      Use this option if you are applying in your personal capacity. If you are
      applying on behalf of a business or legal entity, select "Firm" instead.
    </p>
    <div>
      <mat-slide-toggle class="ccs-toggle" formControlName="is_firm"
        >Applying as a Firm</mat-slide-toggle
      >
    </div>
    @if (!isFirm()) {
      <div class="flex flex-col gap-5">
        <ui-input
          variant="secondary"
          formControlName="first_name"
          type="text"
          label="First Name"
          placeholder="Enter your first name" />
        @if (
          registerForm.controls['first_name'].invalid &&
          registerForm.controls['first_name'].touched
        ) {
          @if (registerForm.controls['first_name'].errors?.['required']) {
            <form-message message="First Name is required." />
          }
          @if (registerForm.controls['first_name'].errors?.['minlength']) {
            <form-message
              message="First Name must be at least 2 characters long." />
          }
          @if (registerForm.controls['first_name'].errors?.['pattern']) {
            <form-message message="First Name should have a valid format" />
          }
        }
      </div>
      <div class="flex flex-col gap-1">
        <ui-input
          variant="secondary"
          formControlName="middle_name"
          type="text"
          label="Middle Name (Optional)"
          placeholder="Enter your middle name" />
        @if (
          registerForm.controls['middle_name'].invalid &&
          registerForm.controls['middle_name'].touched
        ) {
          @if (registerForm.controls['middle_name'].errors?.['pattern']) {
            <form-message message="Middle Name should have a valid format" />
          }
        }
      </div>
      <div class="flex flex-col gap-1">
        <ui-input
          variant="secondary"
          formControlName="last_name"
          type="text"
          label="Last Name"
          placeholder="Enter your last name" />
        @if (
          registerForm.controls['last_name'].invalid &&
          registerForm.controls['last_name'].touched
        ) {
          @if (registerForm.controls['last_name'].errors?.['required']) {
            <form-message message="Last Name is required." />
          }
          @if (registerForm.controls['last_name'].errors?.['minlength']) {
            <form-message
              message="Last Name must be at least 2 characters long." />
          }
          @if (registerForm.controls['last_name'].errors?.['pattern']) {
            <form-message message="Last Name should have a valid format" />
          }
        }
      </div>
    } @else {
      <div class="flex flex-col gap-5">
        <ui-input
          variant="secondary"
          formControlName="first_name"
          type="text"
          label="Firm Name"
          placeholder="Enter your Firm name" />
        @if (
          registerForm.controls['first_name'].invalid &&
          registerForm.controls['first_name'].touched
        ) {
          @if (registerForm.controls['first_name'].errors?.['required']) {
            <form-message message="Firm Name is required." />
          }
          @if (registerForm.controls['first_name'].errors?.['minlength']) {
            <form-message
              message="Firm Name must be at least 2 characters long." />
          }
          @if (registerForm.controls['first_name'].errors?.['pattern']) {
            <form-message message="Firm Name should have a valid format" />
          }
        }
      </div>
    }

    <div class="grid grid-cols-2 gap-x-2 items-stretch">
      <app-select
        className="h-12"
        label="Phone Prefix"
        formControlName="prefix_phone"
        [options]="phonePrefixOptions" />
      <div class="flex flex-col gap-1">
        @if (isPhonePrefixUS) {
          <ui-input
            variant="secondary"
            formControlName="phone_number"
            type="text"
            appPhoneNumberMask
            label="Phone Number (Optional)"
            placeholder="Enter your phone number" />
        } @else {
          <ui-input
            variant="secondary"
            formControlName="phone_number"
            type="text"
            label="Phone Number (Optional)"
            placeholder="Enter your phone number" />
        }
        @if (
          registerForm.controls['phone_number'].invalid &&
          registerForm.controls['phone_number'].touched
        ) {
          @if (registerForm.controls['phone_number'].errors?.['pattern']) {
            <form-message message="Phone Number should has a correct format." />
          }
        }
      </div>
    </div>
    <div class="flex flex-col gap-1">
      <ui-input
        variant="secondary"
        formControlName="email"
        type="email"
        label="Email address"
        placeholder="Enter your email address" />
      @if (
        registerForm.controls['email'].invalid &&
        registerForm.controls['email'].touched
      ) {
        @if (registerForm.controls['email'].errors?.['required']) {
          <form-message message="Email is required." />
        }
        @if (registerForm.controls['email'].errors?.['pattern']) {
          <form-message message="Please enter a valid email address." />
        }
      }
    </div>
    <div class="flex flex-col gap-1">
      <ui-input
        variant="secondary"
        formControlName="password"
        type="password"
        label="Password"
        placeholder="Enter your password" />
      @if (
        registerForm.controls['password'].invalid &&
        registerForm.controls['password'].touched
      ) {
        @if (registerForm.controls['password'].errors?.['required']) {
          <form-message message="Password is required." />
        }
        @if (registerForm.controls['password'].errors?.['minlength']) {
          <form-message
            message="Password must be at least 8 characters long." />
        }
      }
    </div>
    <div class="flex flex-col gap-1">
      <ui-input
        variant="secondary"
        formControlName="confirm_password"
        type="password"
        label="Confirm password"
        placeholder="Confirm your password" />
      @if (
        registerForm.controls['confirm_password'].invalid &&
        registerForm.controls['confirm_password'].touched
      ) {
        @if (registerForm.controls['confirm_password'].errors?.['required']) {
          <form-message message="Confirm password is required." />
        }
      }
      @if (registerForm.errors?.['notMatch']) {
        <form-message message="Passwords do not match." />
      }
    </div>

    <div class="flex flex-col-reverse sm:flex-row gap-2 sm:gap-4">
      <ui-button variant="tertiary" class="w-full" appCloseModal>
        Cancel
      </ui-button>
      <ui-button
        variant="primary"
        class="w-full"
        [disabled]="registerForm.invalid || sending()"
        type="submit">
        @if (sending()) {
          <div class="flex flex-row justify-center items-center gap-2">
            <span appIcon name="spinner" [size]="16"></span>
            Creating
          </div>
        } @else {
          Create
        }
      </ui-button>
    </div>
  </form>
</div>
